module.exports = __webpack_public_path__ + "img/616.Micro.95d4ddb7.svg";